export const ASM_FEATURE = 'asm';
